import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@otp/ui';
import { Link } from 'src/components/common/link';
import { Routes } from 'src/components/common/router/constants';
import { Can } from 'src/utils/can';
import { Actions, AppArea, Subjects } from 'src/graphql/generated/graphql';

export const CreateRoleButton = ({}) => {
  const { t } = useTranslation();

  return (
    <Can I={Actions.Write} a={Subjects.Roles} appArea={AppArea.Admin}>
      <Link to={`${Routes.roles.path}/new`}>
        <Button variant="contained" className="">
          {t('roles.list.create-button')}
        </Button>
      </Link>
    </Can>
  );
};
